import { ProductVariant } from "../../types";

export const showIconOnDisabledColorOptions = false;
export const showDisabledColorOption = true;
export const allProductVariants = ["female", "male"] as ProductVariant[];
export const defaultProductVariant: ProductVariant = "male";
